

import { forwardRef } from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// Custom styles for SoftBox
import SoftBoxRoot from "components/SoftBox/SoftBoxRoot";
import Skeleton from "@mui/material/Skeleton";
/* eslint-disable react/prop-types */

const SoftBox = forwardRef(
  ({ variant, bgColor, color, opacity, borderRadius, shadow, isLoading, ...rest }, ref) => {
    if (isLoading) {
      return <Skeleton variant={variant || "rectangular"} sx={{ bgcolor: 'grey.100', width: '100%', maxWidth: 'none' ,height: '75px'}} />;
    }

    return (
      <SoftBoxRoot
        {...rest}
        ref={ref}
        ownerState={{ variant, bgColor, color, opacity, borderRadius, shadow }}
      />
    );
  }
);

// Setting default values for the props of SoftBox
SoftBox.defaultProps = {
  variant: "contained",
  bgColor: "transparent",
  color: "dark",
  opacity: 1,
  borderRadius: "none",
  shadow: "none",
};

// Typechecking props for the SoftBox
SoftBox.propTypes = {
  variant: PropTypes.oneOf(["contained", "gradient"]),
  bgColor: PropTypes.string,
  color: PropTypes.string,
  opacity: PropTypes.number,
  borderRadius: PropTypes.string,
  shadow: PropTypes.string,
};

export default SoftBox;
